let starGrid = function() {
    let t = this;
    setTimeout(function () {
        let d = new Date();
        t.grid_taks_ini();
    }, 100);
};
export default starGrid;
